import { useNgSession } from "@sazka/ng/ng-session";
import { useAsyncComponent } from "@sazka/utils/composables/use-dynamic-component";
import { useLocalStorage } from "@sazka/utils/use-storage";
const storageName = "has-confirmed-age";
const store = useLocalStorage();

export const confirmAge = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (useNgSession().isLoggedIn.value) {
            resolve();
            return;
        }

        const hasConfirmedAge = store.getItem(storageName);
        if (hasConfirmedAge) {
            resolve();
            return;
        }

        const { showDynamicComponent, hideDynamicComponent } = useAsyncComponent(
            () => import("./age-confirmation-popup.vue"),
            {
                onConfirm: () => {
                    store.setItem(storageName, "true", "essential");
                    resolve();
                    hideDynamicComponent();
                },
                onCancel: () => {
                    reject();
                    hideDynamicComponent();
                },
            }
        );
        showDynamicComponent();
    });
};
